
define('app/board/util/playerList',[
	'jquery',
	'underscore',
	'backbone'
], function($, _, Backbone){
	/* Player Obj properties:
	 * id: null,
			draftablePlayerId: null,
			firstName: null,
			lastName: null,
			exp: null,
			teamFullName: null,
			teamAbbr: null,
			byeWeek: null,
			sport: null,
			position: null,
			drafted: false,
			leagueId: null,
			leagueInstanceId: null,
			dispName: null,
			projectedStats; // {StatCategory, {StatSource, Value}}
	 */
	
	var PlayerList = function(playerArr,lgId,lgInstId){
		if(lgId && lgId >0){
			this.leagueId = lgId;
		}
		if(lgInstId && lgInstId > 0){
			this.leagueInstanceId = lgInstId;
		}
		
		this.players = _(playerArr).map(
    		function(playerData) {
    			var player = {};
    			var position = '';
    			for (var i = 0; i<playerData.positions.length; i++) {
					if(i > 0){
						position += ',';
					}
					position += playerData.positions[i];
				}
    			
    			var fName  = null;
    			var lName  = $("<div>"+playerData.lastName+"</div>").html();
    			
    			var dispName = '';
    			if(playerData.firstName){
					fName  = $("<div>"+playerData.firstName+"</div>").html();
    				dispName = lName + ', ' + fName + ' (' + playerData.teamAbbr + ' ' + position + ')';
    			} else {
    				dispName = lName;
    			}
    			
    			if(playerData.attrs) {
    				player.attrs = playerData.attrs;
    			} else {
    				player.attrs = {};
    			}
    			
    			player.id = playerData.id;
    			player.draftablePlayerId = playerData.draftablePlayerId;
    			player.firstName = fName;
    			player.lastName = lName;
    			player.exp = playerData.exp;
    			player.teamFullName = playerData.teamFullName;
    			player.teamAbbr = playerData.teamAbbr;
    			player.byeWeek = playerData.byeWeek;
    			player.sport = playerData.sport;
    			player.drafted = false;
    			player.leagueId = this.leagueId;
    			player.leagueInstanceId = this.leagueInstanceId;
    			player.dispName = dispName;
    			player.position = position;
    			player.positions = playerData.positions;
    			player.projectedStats = playerData.projectedStats;
    			
    			if(this.leagueInstanceId == 69728){
    				if(player.id == 5123){
    					//Nellie Cruz
    					player.positions = ["RF"];
    					player.position = "RF";
    				} else if(player.id == 9078){
    					//Jose Peraza
    					player.positions = ["2B"];
    					player.position = "2B";
    				} else if(player.id == 4944){
    					//Villar
    					player.positions = ["2B"];
    					player.position = "2B";
    				} else if(player.id == 4530){
    					 //Carlos Santana 1b
    					player.positions = ["1B"];
    					player.position = "1B";
    				} else if(player.id == 4994){
    					 //Pujols 1b
    					player.positions = ["1B"];
    					player.position = "1B";
    				} else if(player.id == 4444){
    					 //Desmond CF
    					player.positions = ["CF"];
    					player.position = "CF";
    				}
    			} else if(this.leagueInstanceId == 134530){
    				if(player.id == 5819){
    					//Baez
    					player.positions = ["2B"];
    					player.position = "2B";
    				}
				} else if(this.leagueInstanceId == 237311){
					//antlercody 
    				if(player.draftablePlayerId == 29451){
    					//Ohtani
    					player.positions = ["DH"];
    					player.position = "DH";
    				} else if(player.draftablePlayerId == 5044){
    					//Manny Machado
    					player.positions = ["DH"];
    					player.position = "DH";
    				} else if(player.draftablePlayerId == 50723){
    					//Isaac Paredes
    					player.positions = ["2B"];
    					player.position = "2B";
    				} 
				} else if(this.leagueInstanceId == 237322){
					//brian cutlip
    				if(player.draftablePlayerId == 34099){
    					//Yordan Alvarez
    					player.positions = ["LF"];
    					player.position = "LF";
    				}
    			} else if(this.leagueInstanceId == 194581){
    				if(player.id == 9448){
    					//Max Muncy
    					player.positions = ["2B"];
    					player.position = "2B";
    				} else if(player.id == 19431){
    					//David Fletcher
    					player.positions = ["SS"];
    					player.position = "SS";
    				//} else if(player.id == 15732){
    					//Ohtani
    				//	player.positions = ["SP"];
    				//	player.position = "SP";
    				} else if(player.id == 21104){
    					//Tommy Edman
    					player.positions = ["2B"];
    					player.position = "2B";
    				}
    			} else if(this.leagueInstanceId == 217451){
    				if(player.id == 17504){
    					//Yordan Alvarez
    					player.positions = ["LF"];
    					player.position = "LF";
    				}
				} else if(this.leagueInstanceId == 217712){
    				if(player.id == 15732){
    					//Ohtani - keep as SP and also as OF
    					player.positions = ["OF"];
    					player.position = "OF";
    				} else if(player.id == 17504){
    					//Yordan Alvarez - OF
    					player.positions = ["OF"];
    					player.position = "OF";
    				} else if(player.id == 5123){
    					//Nelson Cruz - OF
    					player.positions = ["OF"];
    					player.position = "OF";
    				} else if(player.id == 18325){
    					//Ty France - 1B
    					player.positions = ["1B"];
    					player.position = "1B";
    				} else if(player.id == 4942){
    					//Marwin Gonzalez - OF
    					player.positions = ["OF"];
    					player.position = "OF";
    				} else if(player.id == 13033){
    					//Lourdes Guirriel - OF
    					player.positions = ["OF"];
    					player.position = "OF";
    				} else if(player.id == 20778){
    					//Joe Conner - 1B
    					player.positions = ["1B"];
    					player.position = "1B";
    				} else if(player.id == 18010){
    					//Scott Kingery - OF
    					player.positions = ["OF"];
    					player.position = "OF";
    				} else if(player.id == 5821){
    					//Tommy LaStella 2B
    					player.positions = ["2B"];
    					player.position = "2B";
    				} else if(player.id == 12749){
    					//Trey Mancini - 1B
    					player.positions = ["1B"];
    					player.position = "1B";
    				} else if(player.id == 6002){
    					//JD Martinez - OF
    					player.positions = ["OF"];
    					player.position = "OF";
    				} else if(player.id == 17540){
    					//Jeff McNeil - 2B
    					player.positions = ["2B"];
    					player.position = "2B";
    				} else if(player.id == 4624){
    					//Mike Moustakas - 3B
    					player.positions = ["3B"];
    					player.position = "3B";
    				} else if(player.id == 9448){
    					//Max Muncy - 2B
    					player.positions = ["2B"];
    					player.position = "2B";
    				} else if(player.id == 17118){
    					//Sheldon Neuse - 2B
    					player.positions = ["2B"];
    					player.position = "2B";
    				} else if(player.id == 4672){
    					//Danny Santana - OF
    					player.positions = ["OF"];
    					player.position = "OF";
    				} else if(player.id == 20651){
    					//Gavin Sheets - 1B
    					player.positions = ["1B"];
    					player.position = "1B";
    				} else if(player.id == 5899){
    					//Dominic Smith - 1B
    					player.positions = ["1B"];
    					player.position = "1B";
    				} else if(player.id == 4326){
    					//Giancarlo Stanton - OF
    					player.positions = ["OF"];
    					player.position = "OF";
    				} else if(player.id == 13018){
    					//Luis Torrens - C
    					player.positions = ["C"];
    					player.position = "C";
    				} else if(player.id == 20875){
    					//Daulton Varsho - OF
    					player.positions = ["OF"];
    					player.position = "OF";
    				} else if(player.id == 4944){
    					//Jonathan Villar - 3B
    					player.positions = ["3B"];
    					player.position = "3B";
    				}
    			} else if(this.leagueInstanceId == 201280){
					if(player.draftablePlayerId == 34705){
    					//4,Ronald Acuna Jr.,94,Braves,CF
    					player.positions = ["CF"]; player.position = "CF";
    				} else if(player.draftablePlayerId == 44214){
    					//35,Freddy Peralta,86,Brewers,SP
    					player.positions = ["SP"]; player.position = "SP";
    				} else if(player.draftablePlayerId == 24172){
    					//37,Teoscar Hernandez,86,Blue Jays,LF  <-- Change
						player.positions = ["LF"]; player.position = "LF";
					} else if(player.draftablePlayerId == 29451){
    					//38,Shohei Ohtani,86,Angels,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 15135){
    					//40,Ketel Marte,86,Diamondbacks,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 49958){
    					//45,Bryan Reynolds,85,Pirates,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 5501){
    					//54,Marcus Semien,85,Blue Jays,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 5505){
    					//57,Avisail Garcia,84,Brewers,RF  <-- Change
						player.positions = ["RF"]; player.position = "RF";
					} else if(player.draftablePlayerId == 34710){
    					//59,Kyle Tucker,84,Astros,RF  <-- Change
						player.positions = ["RF"]; player.position = "RF";
					} else if(player.draftablePlayerId == 5818){
    					//80,Jean Segura,83,Phillies,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 11530){
    					//93,Joey Gallo,82,Yankees,RF  <-- Change
						player.positions = ["RF"]; player.position = "RF";
					} else if(player.draftablePlayerId == 22179){
    					//101,Adam Engel,82,White Sox,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 28976){
    					//102,Alex Verdugo,82,Red Sox,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 5332){
    					//104,Giancarlo Stanton,82,Yankees,LF  <-- Change
						player.positions = ["LF"]; player.position = "LF";
					} else if(player.draftablePlayerId == 15090){
    					//107,Adam Duvall,81,Braves,RF  <-- Change
						player.positions = ["RF"]; player.position = "RF";
					} else if(player.draftablePlayerId == 44153){
    					//111,David Fletcher,81,Angels,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 50101){
    					//113,Tommy Edman,81,Cardinals,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 22212){
    					//122,Jesse Winker,81,Reds,LF  <-- Change
						player.positions = ["LF"]; player.position = "LF";
					} else if(player.draftablePlayerId == 21170){
    					//143,Chris Taylor,80,Dodgers,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 34099){
    					//150,Yordan Alvarez,80,Astros,LF  <-- Change
						player.positions = ["LF"]; player.position = "LF";
					} else if(player.draftablePlayerId == 49447){
    					//153,Michael Kopech,80,White Sox,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 44191){
    					//155,Isiah Kiner-Falefa,80,Rangers,SS  <-- Change
						player.positions = ["SS"]; player.position = "SS";
					} else if(player.draftablePlayerId == 15496){
    					//172,Aledmys Diaz,79,Astros,3B  <-- Change
						player.positions = ["3B"]; player.position = "3B";
					} else if(player.draftablePlayerId == 29353){
    					//177,Ranger Suarez,79,Phillies,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 26347){
    					//181,Austin Hays,79,Orioles,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 49353){
    					//182,Ryan Mountcastle,79,Orioles,1B  <-- Change
						player.positions = ["1B"]; player.position = "1B";
					} else if(player.draftablePlayerId == 51431){
    					//184,Nico Hoerner,79,Cubs,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 7500){
    					//185,J.D. Martinez,79,Red Sox,LF  <-- Change
						player.positions = ["LF"]; player.position = "LF";
					} else if(player.draftablePlayerId == 19026){
    					//187,Whit Merrifield,79,Royals,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 15600){
    					//206,Raimel Tapia,78,Rockies,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 28369){
    					//207,Ryan McMahon,78,Rockies,3B  <-- Change
						player.positions = ["3B"]; player.position = "3B";
					} else if(player.draftablePlayerId == 15558){
    					//211,Tyler Naquin,78,Reds,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 6129){
    					//216,Nelson Cruz,78,Rays,RF  <-- Change
						player.positions = ["RF"]; player.position = "RF";
					} else if(player.draftablePlayerId == 5905){
    					//221,Randal Grichuk,78,Blue Jays,RF  <-- Change
						player.positions = ["RF"]; player.position = "RF";
					} else if(player.draftablePlayerId == 8672){
    					//236,Enrique Hernandez,78,Red Sox,2B First Name originally Kike  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 29333){
    					//240,Yonny Chirinos,77,Rays,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 44295){
    					//244,Jeff McNeil,77,Mets,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 5865){
    					//248,Andrew McCutchen,77,Phillies,LF  <-- Change
						player.positions = ["LF"]; player.position = "LF";
					} else if(player.draftablePlayerId == 49487){
    					//250,Connor Joe,77,Rockies,1B  <-- Change
						player.positions = ["1B"]; player.position = "1B";
					} else if(player.draftablePlayerId == 49631){
    					//252,Josh Rojas,77,Diamondbacks,LF  <-- Change
						player.positions = ["LF"]; player.position = "LF";
					} else if(player.draftablePlayerId == 50072){
    					//255,Kyle Lewis,77,Mariners,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 5682){
    					//275,Max Kepler,77,Twins,RF  <-- Change
						player.positions = ["RF"]; player.position = "RF";
					} else if(player.draftablePlayerId == 65072){
    					//282,Ha-seong Kim,76,Padres,SS  <-- Change
						player.positions = ["SS"]; player.position = "SS";
					} else if(player.draftablePlayerId == 6172){
    					//283,Gerardo Parra,76,Nationals,RF  <-- Change
						player.positions = ["RF"]; player.position = "RF";
					} else if(player.draftablePlayerId == 52473){
    					//291,Tyrone Taylor,76,Brewers,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 49962){
    					//292,David Bednar,76,Pirates,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 28912){
    					//293,J.D. Davis,76,Mets,3B  <-- Change
						player.positions = ["3B"]; player.position = "3B";
					} else if(player.draftablePlayerId == 22216){
    					//319,Brett Phillips,76,Rays,CF  <-- Chang
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 15586){
    					//328,Harold Ramirez,76,Indians,RF  <-- Change
						player.positions = ["RF"]; player.position = "RF";
					} else if(player.draftablePlayerId == 33605){
    					//335,Nicky Lopez,76,Royals,SS  <-- Change
						player.positions = ["SS"]; player.position = "SS";
					} else if(player.draftablePlayerId == 44483){
    					//338,Ramon Urias,76,Orioles,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 50107){
    					//345,Dylan Carlson,75,Cardinals,RF  <-- Change
						player.positions = ["RF"]; player.position = "RF";
					} else if(player.draftablePlayerId == 66681){
    					//349,Jonathan India,75,Reds,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 49482){
    					//356,Kyle Farmer,75,Reds,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 44067){
    					//359,Willians Astudillo,75,Twins,1B  <-- Change
						player.positions = ["1B"]; player.position = "1B";
					} else if(player.draftablePlayerId == 62187){
    					//360,Luis Patino,75,Rays,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 52507){
    					//361,Jordan Romano,75,Blue Jays,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 51829){
    					//362,Chas McCormick,75,Astros,LF  <-- Change
						player.positions = ["LF"]; player.position = "LF";
					} else if(player.draftablePlayerId == 52390){
    					//383,Jazz Chisholm,74,Marlins,SS  <-- Change
						player.positions = ["SS"]; player.position = "SS";
					} else if(player.draftablePlayerId == 28842){
    					//384,Brian Goodwin,74,White Sox,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 33730){
    					//385,LaMonte Wade Jr.,74,Giants,LF  <-- Change
						player.positions = ["LF"]; player.position = "LF";
					} else if(player.draftablePlayerId == 44232){
    					//386,Kevin Newman,74,Pirates,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 50064){
    					//393,Dylan Moore,74,Mariners,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 49479){
    					//400,Lucas Sims,74,Reds,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 44071){
    					//404,Jake Cave,74,Twins,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 61184){
    					//414,Seth Brown,74,Athletics,1B  <-- Change
						player.positions = ["1B"]; player.position = "1B";
					} else if(player.draftablePlayerId == 28596){
    					//420,Miguel Andujar,74,Yankees,LF  <-- Change
						player.positions = ["LF"]; player.position = "LF";
					} else if(player.draftablePlayerId == 49452){
    					//421,Zach Thompson,73,Marlins,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 49325){
    					//426,Rafael Ortega,73,Cubs,RF  <-- Change
						player.positions = ["RF"]; player.position = "RF";
					} else if(player.draftablePlayerId == 33788){
    					//427,Jon Berti,73,Marlins,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 29394){
    					//428,Mauricio Dubon,73,Giants,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 19081){
    					//433,Matt Carpenter,73,Cardinals,3B  <-- Change
						player.positions = ["3B"]; player.position = "3B";
					} else if(player.draftablePlayerId == 60875){
    					//435,Sam Coonrod,73,Phillies,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 22210){
    					//441,Aristides Aquino,73,Reds,RF  <-- Change
						player.positions = ["RF"]; player.position = "RF";
					} else if(player.draftablePlayerId == 5636){
    					//443,Jarrod Dyson,73,Royals,RF  <-- Change
						player.positions = ["RF"]; player.position = "RF";
					} else if(player.draftablePlayerId == 49682){
    					//447,John Curtiss,73,Brewers,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 33678){
    					//454,Josh Naylor,73,Indians,1B  <-- Change
						player.positions = ["1B"]; player.position = "1B";
					} else if(player.draftablePlayerId == 44522){
    					//459,Kolby Allard,73,Rangers,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 44848){
    					//462,Jonathan Loaisiga,73,Yankees,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 65326){
    					//466,Tyler Wells,73,Orioles,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 15150){
    					//470,Travis Jankowski,72,Phillies,RF  <-- Change
						player.positions = ["RF"]; player.position = "RF";
					} else if(player.draftablePlayerId == 21050){
    					//474,Ehire Adrianza,72,Braves,SS  <-- Change
						player.positions = ["SS"]; player.position = "SS";
					} else if(player.draftablePlayerId == 61990){
    					//475,Shogo Akiyama,72,Reds,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 28892){
    					//478,Jimmy Nelson,72,Dodgers,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 5678){
    					//479,Danny Santana,72,Red Sox,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 15349){
    					//480,Jurickson Profar,72,Padres,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 5321){
    					//483,Donovan Solano,72,Giants,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 22243){
    					//504,Lewis Brinson,72,Marlins,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 49827){
    					//506,Luis Guillorme,72,Mets,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 44151){
    					//507,Taylor Ward,72,Angels,3B  <-- Change
						player.positions = ["3B"]; player.position = "3B";
					} else if(player.draftablePlayerId == 26228){
    					//513,Paolo Espino,72,Nationals,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 44136){
    					//522,Josh James,72,Astros,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 28851){
    					//529,Leury Garcia,72,White Sox,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 61994){
    					//530,Andrew Vaughn,72,White Sox,LF  <-- Change
						player.positions = ["LF"]; player.position = "LF";
					} else if(player.draftablePlayerId == 49356){
    					//544,Rio Ruiz,72,Rockies,3B  <-- Change
						player.positions = ["3B"]; player.position = "3B";
					} else if(player.draftablePlayerId == 49386){
    					//547,Michael Chavis,72,Pirates,3B  <-- Change
						player.positions = ["3B"]; player.position = "3B";
					} else if(player.draftablePlayerId == 25986){
    					//557,Dominic Smith,71,Mets,LF  <-- Change
						player.positions = ["LF"]; player.position = "LF";
					} else if(player.draftablePlayerId == 6073){
    					//561,Brad Miller,71,Phillies,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 6164){
    					//567,Chris Owings,71,Rockies,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 28456){
    					//576,Yandy Diaz,71,Rays,1B  <-- Change
						player.positions = ["1B"]; player.position = "1B";
					} else if(player.draftablePlayerId == 49460){
    					//585,Danny Mendick,71,White Sox,SS  <-- Change
						player.positions = ["SS"]; player.position = "SS";
					} else if(player.draftablePlayerId == 20017){
    					//589,Chad Pinder,71,Athletics,LF  <-- Change
						player.positions = ["LF"]; player.position = "LF";
					} else if(player.draftablePlayerId == 44035){
    					//592,Niko Goodrum,71,Tigers,SS  <-- Change
						player.positions = ["SS"]; player.position = "SS";
					} else if(player.draftablePlayerId == 49648){
    					//597,Jake Kalish,71,Royals,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 28995){
    					//601,Christian Arroyo,71,Red Sox,3B  <-- Change
						player.positions = ["3B"]; player.position = "3B";
					} else if(player.draftablePlayerId == 26277){
    					//603,Greg Allen,71,Yankees,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 11538){
    					//610,Wilmer Difo,70,Pirates,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 29377){
    					//611,Wily Peralta,70,Tigers,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 44134){
    					//613,Billy McKinney,70,Dodgers,LF  <-- Change
						player.positions = ["LF"]; player.position = "LF";
					} else if(player.draftablePlayerId == 28913){
    					//615,Colin Moran,70,Pirates,1B  <-- Change
						player.positions = ["1B"]; player.position = "1B";
					} else if(player.draftablePlayerId == 44977){
    					//621,Erik Swanson,70,Mariners,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 44199){
    					//626,David Bote,70,Cubs,3B  <-- Change
						player.positions = ["3B"]; player.position = "3B";
					} else if(player.draftablePlayerId == 50179){
    					//629,Eli White,70,Rangers,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 67566){
    					//652,Lars Nootbaar,69,Cardinals,LF  <-- Change
						player.positions = ["LF"]; player.position = "LF";
					} else if(player.draftablePlayerId == 50110){
    					//657,Lane Thomas,69,Nationals,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 28777){
    					//659,Caleb Smith,69,Diamondbacks,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 5541){
    					//662,Asdrubal Cabrera,69,Diamondbacks,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 49883){
    					//663,Jorge Mateo,69,Orioles,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 45126){
    					//667,Ryan Thompson,69,Rays,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 62048){
    					//671,Nate Pearson,69,Blue Jays,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 28597){
    					//682,Tyler Wade,69,Yankees,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 49299){
    					//686,Rob Refsnyder,68,Twins,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 67468){
    					//690,Johneshwy Fargas,68,Cubs,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 18495){
    					//691,Luis Perdomo,68,Brewers,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 51284){
    					//700,Hoy Jun Park,68,Pirates,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 51627){
    					//706,Alex Young,68,Indians,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 20024){
    					//715,Brent Suter,68,Brewers,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 64783){
    					//718,Phil Bickford,68,Dodgers,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 49422){
    					//728,Justin Steele,68,Cubs,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 6120){
    					//741,Mitch Moreland,68,Athletics,1B  <-- Change
						player.positions = ["1B"]; player.position = "1B";
					} else if(player.draftablePlayerId == 15509){
    					//743,Michael Fulmer,68,Tigers,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 29371){
    					//745,Gregory Soto,68,Tigers,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 64755){
    					//746,Ljay Newsome,68,Mariners,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 22187){
    					//750,Jakob Junis,68,Royals,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 15353){
    					//755,Tyler Chatwood,68,Giants,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 67597){
    					//764,Jarren Duran,67,Red Sox,RF  <-- Change
						player.positions = ["RF"]; player.position = "RF";
					} else if(player.draftablePlayerId == 65024){
    					//784,Jordan Sheffield,67,Rockies,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 61912){
    					//787,Blake Taylor,67,Astros,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 44144){
    					//789,Taylor Cole,67,Angels,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 49448){
    					//791,Jimmy Lambert,67,White Sox,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 44045){
    					//793,Jorge Lopez,67,Orioles,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 61927){
    					//803,Carlos Hernandez,67,Royals,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 64946){
    					//818,Alec Bettinger,66,Brewers,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 6133){
    					//828,Chase Anderson,66,Phillies,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 49901){
    					//830,Adonis Medina,66,Phillies,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 50206){
    					//831,Austin Voth,66,Nationals,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 44876){
    					//840,Justus Sheffield,66,Mariners,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 51460){
    					//861,Trevor Megill,65,Cubs,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 49752){
    					//863,Angel Perdomo,65,Brewers,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 64943){
    					//874,Keegan Thompson,65,Cubs,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 49478){
    					//878,Tony Santillan,65,Reds,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 34736){
    					//892,Carter Kieboom,65,Nationals,3B  <-- Change
						player.positions = ["3B"]; player.position = "3B";
					} else if(player.draftablePlayerId == 49495){
    					//895,Taylor Trammell,65,Mariners,LF  <-- Change
						player.positions = ["LF"]; player.position = "LF";
					} else if(player.draftablePlayerId == 44984){
    					//896,Taylor Hearn,65,Rangers,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 61985){
    					//903,Yoshitomo Tsutsugo,65,Pirates,3B  <-- Change
						player.positions = ["3B"]; player.position = "3B";
					} else if(player.draftablePlayerId == 52215){
    					//905,Enoli Paredes,65,Astros,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 49336){
    					//914,Dean Kremer,65,Orioles,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 50723){
    					//917,Isaac Paredes,65,Tigers,3B  <-- Change
						player.positions = ["3B"]; player.position = "3B";
					} else if(player.draftablePlayerId == 49945){
    					//926,Brandon Waddell,64,Cardinals,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 64956){
    					//938,Stuart Fairchild,64,Diamondbacks,LF  <-- Change
						player.positions = ["LF"]; player.position = "LF";
					} else if(player.draftablePlayerId == 51158){
    					//947,Mauricio Llovera,64,Phillies,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 64744){
    					//951,Seth Romero,64,Nationals,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 29136){
    					//952,Jefry Rodriguez,64,Nationals,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 61955){
    					//971,Ashton Goudeau,64,Rockies,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 49555){
    					//972,Tyler Nevin,64,Orioles,1B  <-- Change
						player.positions = ["1B"]; player.position = "1B";
					} else if(player.draftablePlayerId == 49704){
    					//975,Michael Hermosillo,63,Cubs,RF  <-- Change
						player.positions = ["RF"]; player.position = "RF";
					} else if(player.draftablePlayerId == 49505){
    					//979,J.C. Mejia,63,Indians,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 49897){
    					//984,Tyler Gilbert,63,Diamondbacks,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 49634){
    					//985,Ronnie Dawson,63,Astros,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 29326){
    					//986,Domingo Acevedo,63,Athletics,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 64963){
    					//987,Mason Thompson,63,Nationals,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 5616){
    					//989,Ervin Santana,63,Royals,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 44492){
    					//993,Taylor Clarke,63,Diamondbacks,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 29335){
    					//994,Jose Mujica,63,Rockies,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 49938){
    					//996,Chad Kuhl,63,Pirates,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 21417){
    					//997,Carson Fulmer,63,Reds,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 44239){
    					//1002,Daniel Ponce de Leon,63,Cardinals,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 50219){
    					//1008,Andrew Stevenson,63,Nationals,LF  <-- Change
						player.positions = ["LF"]; player.position = "LF";
					} else if(player.draftablePlayerId == 49609){
    					//1013,Bryan Abreu,63,Astros,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 5480){
    					//1014,Jose Quintana,63,Angels,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 49700){
    					//1016,Matt Thaiss,63,Angels,1B  <-- Change
						player.positions = ["1B"]; player.position = "1B";
					} else if(player.draftablePlayerId == 20072){
    					//1022,JaCoby Jones,63,Tigers,CF  <-- Change
						player.positions = ["CF"]; player.position = "CF";
					} else if(player.draftablePlayerId == 23133){
    					//1026,Brent Honeywell Jr.,63,Rays,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 64794){
    					//1028,Jonathan Stiever,63,White Sox,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 5971){
    					//1033,Garrett Richards,63,Red Sox,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 61983){
    					//1037,Michael Rucker,62,Cubs,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 67594){
    					//1038,Reiss Knehr,62,Padres,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 67596){
    					//1043,Charlie Barnes,62,Twins,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 21481){
    					//1044,Jhoulys Chacin,62,Rockies,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 50606){
    					//1050,Riley Smith,62,Diamondbacks,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 9197){
    					//1051,Daniel Norris,62,Brewers,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 61939){
    					//1054,Kyle Cody,62,Rangers,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 52283){
    					//1055,Eduard Bazardo,62,Red Sox,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 51073){
    					//1058,Martin Perez,62,Red Sox,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 67458){
    					//1060,Nick Allgeyer,61,Blue Jays,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 67570){
    					//1062,Konner Wade,61,Orioles,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 20205){
    					//1070,Trevor Williams,61,Mets,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 29525){
    					//1071,Julian Fernandez,61,Rockies,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 44968){
    					//1073,Patrick Murphy,61,Nationals,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 49485){
    					//1080,Alex Blandino,60,Reds,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 28366){
    					//1084,Jeff Hoffman,60,Reds,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 52453){
    					//1088,Jacob Waguespack,60,Blue Jays,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 51164){
    					//1089,Nick Maton,60,Phillies,SS  <-- Change
						player.positions = ["SS"]; player.position = "SS";
					} else if(player.draftablePlayerId == 44966){
    					//1097,Yennsy Diaz,59,Mets,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 49999){
    					//1099,Conner Menez,59,Giants,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 61934){
    					//1100,Miguel Yajure,59,Pirates,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 12519){
    					//1103,Chi Chi Gonzalez,59,Rockies,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 67750){
    					//1115,Justin Bruihl,58,Dodgers,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 52249){
    					//1116,Otto Lopez,58,Blue Jays,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 51775){
    					//1118,Daniel Camarena,58,Padres,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 67578){
    					//1120,Aaron Ashby,58,Brewers,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 65022){
    					//1126,Luis Oviedo,58,Pirates,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 50630){
    					//1128,Vimael Machin,58,Athletics,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 61956){
    					//1137,Antonio Santos,57,Rockies,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 67568){
    					//1142,Justin Garza,57,Indians,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 50093){
    					//1146,Jake Woodford,57,Cardinals,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 51638){
    					//1148,Rylan Bannon,57,Orioles,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 29427){
    					//1152,Dennis Santana,57,Rangers,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 50215){
    					//1154,Adrian Sanchez,56,Nationals,2B  <-- Change
						player.positions = ["2B"]; player.position = "2B";
					} else if(player.draftablePlayerId == 49834){
    					//1158,Chance Adams,56,Royals,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 67564){
    					//1161,Jake Cousins,56,Brewers,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 49615){
    					//1162,Ryan Hartman,56,Orioles,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 64743){
    					//1164,Wes Benjamin,56,Rangers,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 50743){
    					//1168,Jorge Guzman,55,Marlins,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 67535){
    					//1173,Mac Sceroler,55,Reds,SP  <-- Change
						player.positions = ["SP"]; player.position = "SP";
					} else if(player.draftablePlayerId == 49804){
    					//1175,Anthony Kay,55,Blue Jays,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 64927){
    					//1181,Jay Groome,55,Red Sox,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 67735){
    					//1188,Sean Guenther,54,Marlins,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					} else if(player.draftablePlayerId == 49769){
    					//1195,Chase De Jong,50,Pirates,RP  <-- Change
						player.positions = ["RP"]; player.position = "RP";
					}
				} else if(this.leagueInstanceId == 257149){
					//brian cutlip
					if(player.draftablePlayerId == 5329){
	    				//Marcel Ozuna
	    				player.positions = ["LF"]; player.position = "LF";
	    			} else if (player.draftablePlayerId == 29362){
	    				//Eloy Jimenez
	    				player.positions = ["LF"]; player.position = "LF";
	    			}
    			} else if(this.leagueInstanceId == 256905){
					//Trey Garrison
					if(player.draftablePlayerId == 5082){
	    				//Xander Bogaerts
	    				player.positions = ["SS"]; player.position = "SS";
	    			} else if (player.draftablePlayerId == 75133){
	    				//Matt McLain
	    				player.positions = ["2B"]; player.position = "2B";
	    			} else if (player.draftablePlayerId == 76601){
	    				//Jackson Holliday
	    				player.positions = ["2B"]; player.position = "2B";
	    			}
    			} else if(this.leagueInstanceId == 257448){
					//Al Rodack
					if(player.draftablePlayerId == 7048){
						// Mookie Betts
						player.positions = ["SS"]; player.position = "SS";
					} else if (player.draftablePlayerId == 34142){
						// Cavan Biggio 
						player.positions = ["3B"]; player.position = "3B";
					} else if (player.draftablePlayerId == 62049){
						// Alec Bohm
						player.positions = ["3B"]; player.position = "3B";
					} else if (player.draftablePlayerId == 6834){
						// Kris Bryant
						player.positions = ["1B"]; player.position = "1B";		
					} else if (player.draftablePlayerId == 72051){
						// Elly De La Cruz
						player.positions = ["SS"]; player.position = "SS";
					} else if (player.draftablePlayerId == 51835){
						// Brendan Donovan
						player.positions = ["LF"]; player.position = "LF";	
					} else if (player.draftablePlayerId == 50101){
						// Tommy Edman
						player.positions = ["2B"]; player.position = "2B";	
					} else if (player.draftablePlayerId == 71538){
						// Gunnar Henderson
						player.positions = ["SS"]; player.position = "SS";
					} else if (player.draftablePlayerId == 49791){
						// Alex Kiriloff
						player.positions = ["1B"]; player.position = "1B";
					} else if (player.draftablePlayerId == 49699){
						// Tommy LaStella
						player.positions = ["2B"]; player.position = "2B";
					} else if (player.draftablePlayerId == 6205){
						// DJ LeMahieu
						player.positions = ["3B"]; player.position = "3B";
					} else if (player.draftablePlayerId == 7500){
						// JD Martinez
						player.positions = ["LF"]; player.position = "LF";
					} else if (player.draftablePlayerId == 75133){
						// Matt McLain
						player.positions = ["2B"]; player.position = "2B";
					} else if (player.draftablePlayerId == 5865){
						// Andrew McCutchen
						player.positions = ["LF"]; player.position = "LF";
					} else if (player.draftablePlayerId == 51784){
						// Elehuris Montero
						player.positions = ["1B"]; player.position = "1B";
					} else if (player.draftablePlayerId == 29451){
						// Shohei Ohtani
						player.positions = ["LF"]; player.position = "LF";
					} else if (player.draftablePlayerId == 5329){
						// Marcell Ozuna
						player.positions = ["LF"]; player.position = "LF";
					} else if (player.draftablePlayerId == 49792){
						// Luke Raley
						player.positions = ["LF"]; player.position = "LF";
					} else if (player.draftablePlayerId == 5332){
						// Giancarlo Stanton
						player.positions = ["LF"]; player.position = "LF";
					} else if (player.draftablePlayerId == 71543){
						// Spencer Steer
						player.positions = ["LF"]; player.position = "LF";
					} else if (player.draftablePlayerId == 21170){
						// Chris Taylor
						player.positions = ["LF"]; player.position = "LF";
					} else if (player.draftablePlayerId == 7034){
						// Justin Turner
						player.positions = ["1B"]; player.position = "1B";
					} else if (player.draftablePlayerId == 75618){
						// Jordan Westburg
						player.positions = ["3B"]; player.position = "3B";
					}
				} else if(this.leagueInstanceId == 276217){
					if(player.draftablePlayerId == 22803){
	    				//Cody Bellinger
	    				player.positions = ["RF"]; player.position = "RF";
	    			} else if(player.draftablePlayerId == 52480){
	    				//McCarthy, Jake
	    				player.positions = ["RF"]; player.position = "RF";
	    			} else if(player.draftablePlayerId == 76602){
	    				//Manzardo, Kyle
	    				player.positions = ["DH"]; player.position = "DH";
	    			} else if(player.draftablePlayerId == 72146){
	    				//Yoshida, Masataka
	    				player.positions = ["DH"]; player.position = "DH";
	    			} else if(player.draftablePlayerId == 51630){
	    				//Smith, Pavin
	    				player.positions = ["1B"]; player.position = "1B";
	    			} else if(player.draftablePlayerId == 76011){
	    				//Goodman, Hunter
	    				player.positions = ["RF"]; player.position = "RF";
	    			}
    			} else if(this.leagueInstanceId == 276190) {
					if(player.draftablePlayerId == 5945){
	    				//Jose Altuve - CF 5945
	    				player.positions = ["CF"]; player.position = "CF";
	    			} else if(player.draftablePlayerId == 5082){
	    				//Xander Bogaerts – SS 5082
						player.positions = ["SS"]; player.position = "SS";
	    			} else if(player.draftablePlayerId == 6834){
						//Kris Bryant – 1B 6834
						player.positions = ["1B"]; player.position = "1B";
	    			} else if(player.draftablePlayerId == 71547){
						//Alec Burleson – 1B 71547
						player.positions = ["1B"]; player.position = "1B";
	    			} else if(player.draftablePlayerId == 81900){
						//Kristian Campbell – 2B 81900
						player.positions = ["2B"]; player.position = "2B";
	    			} else if(player.draftablePlayerId == 29365){
						//Willi Castro – 2B 29365
						player.positions = ["2B"]; player.position = "2B";
	    			} else if(player.draftablePlayerId == 52390){
						//Jazz Chisholm – 2B 52390
						player.positions = ["2B"]; player.position = "2B";
	    			} else if(player.draftablePlayerId == 15574){
						//Willson Contreras – 1B 15574
						player.positions = ["1B"]; player.position = "1B";
	    			} else if(player.draftablePlayerId == 50779){
						//O’Neil Cruz - CF 50779
						player.positions = ["CF"]; player.position = "CF";
	    			} else if(player.draftablePlayerId == 51835){
						//Brendan Donovan – 2B 51835
						player.positions = ["2B"]; player.position = "2B";
	    			} else if(player.draftablePlayerId == 50101){
						//Tommy Edman – 2B 50101
						player.positions = ["2B"]; player.position = "2B";
	    			} else if(player.draftablePlayerId == 76059){
						//Tyler Fitzgerald – 2B 76059
						player.positions = ["2B"]; player.position = "2B";
	    			} else if(player.draftablePlayerId == 68536){
						//Bowden Francis - SP 68536
						player.positions = ["SP"]; player.position = "SP";
	    			} else if(player.draftablePlayerId == 76011){
						//Hunter Goodman – 1B 76011
						player.positions = ["1B"]; player.position = "1B";
	    			} else if(player.draftablePlayerId == 8672){
						//Enrique Hernandez - SS 8672
						player.positions = ["SS"]; player.position = "SS";
	    			} else if(player.draftablePlayerId == 49937){
						//Clay Holmes - SP 49937
						player.positions = ["SP"]; player.position = "SP";
	    			} else if(player.draftablePlayerId == 52460){
						//Grant Holmes - SP 52460
						player.positions = ["SP"]; player.position = "SP";
	    			} else if(player.draftablePlayerId == 44191){
						//Isiah Kiner-Falefa – SS 44191
						player.positions = ["SS"]; player.position = "SS";
	    			} else if(player.draftablePlayerId == 7376){
						//Nick Martinez - SP 7376
						player.positions = ["SP"]; player.position = "SP";
	    			} else if(player.draftablePlayerId == 68514){
						//Jose Miranda – 1B 68514
						player.positions = ["1B"]; player.position = "1B";
	    			} else if(player.draftablePlayerId == 50064){
						//Dylan Moore – 2B 50064
						player.positions = ["2B"]; player.position = "2B";
	    			} else if(player.draftablePlayerId == 29451){
						//Shohei Ohtani – CF 29451 
						player.positions = ["CF"]; player.position = "CF";
	    			} else if(player.draftablePlayerId == 64944){
						//Christopher Morel – CF 64944
						player.positions = ["CF"]; player.position = "CF";
	    			} else if(player.draftablePlayerId == 18466){
						//Jorge Polanco – 3B 18466
						player.positions = ["3B"]; player.position = "3B";
	    			} else if(player.draftablePlayerId == 51341){
						//Luis Rengifo – 2B 51341
						player.positions = ["2B"]; player.position = "2B";
	    			} else if(player.draftablePlayerId == 49794){
						//Brent Rooker - CF 49794
						player.positions = ["CF"]; player.position = "CF";
	    			} else if(player.draftablePlayerId == 12544){
						//Kyle Schwarber – CF 12544
						player.positions = ["CF"]; player.position = "CF";
	    			} else if(player.draftablePlayerId == 81898){
						//Matt Shaw – 3B 81898
						player.positions = ["3B"]; player.position = "3B";
	    			} else if(player.draftablePlayerId == 5332){
						//Giancarlo Stanton - CF 5332
						player.positions = ["CF"]; player.position = "CF";
	    			} else if(player.draftablePlayerId == 71543){
						//Spencer Steer – 1B 71543
						player.positions = ["1B"]; player.position = "1B";
	    			} else if(player.draftablePlayerId == 50136){
						//Jake Croneworth – 2B 50136
						player.positions = ["2B"]; player.position = "2B";
	    			} else if(player.draftablePlayerId == 75133){
						//Matt McClain – 2B 75133
						player.positions = ["2B"]; player.position = "2B";
	    			}
				} else if(this.leagueInstanceId == 276481) {
					if(player.draftablePlayerId == 71543){
						//Spencer Steer @1B 71543
						player.positions = ["1B"]; player.position = "1B";
	    			} else if(player.draftablePlayerId == 75133){
						//Matt McLain @2B 75133
						player.positions = ["2B"]; player.position = "2B";
	    			} else if(player.draftablePlayerId == 52390){
						//Jazz Chisholm @3B 52390
						player.positions = ["3B"]; player.position = "3B";
	    			} else if(player.draftablePlayerId == 44588){
						//Jake Burger @3B 44588
						player.positions = ["3B"]; player.position = "3B";
	    			} else if(player.draftablePlayerId == 75618){
						//Jordan Westburg @2B 75618
						player.positions = ["2B"]; player.position = "2B";
	    			} else if(player.draftablePlayerId == 28456){
						//Yandy Diaz @1B 28456
						player.positions = ["1B"]; player.position = "1B";
	    			} else if(player.draftablePlayerId == 68964){
						//Ceddane Rafaela @SS 68964
						player.positions = ["SS"]; player.position = "SS";
	    			}	
				}
    			          
    			return player;
    		},this
    	);
	};
	
	PlayerList.prototype.findPlayerByPlayerId = function (playerId) {
		return _.find(this.players, function(player){ 
			var foundPlayerId = player.id;
			var curId = playerId;
			var response = foundPlayerId == curId;
			return response;}
		);
	};
	
	PlayerList.prototype.findPlayerByDraftPlayerId = function (draftPlayerId) {
		return _.find(this.players, function(player){ 
			var foundPlayerId = player.draftablePlayerId;
			var curId = draftPlayerId;
			var response = foundPlayerId == curId;
			return response;}
		);
	};
	
	PlayerList.prototype.findPlayerByDispName = function (dispName) {
		return _.find(this.players, function(player){ return player.dispName == dispName;});
	};
	
	PlayerList.prototype.undraftedPlayers = function (prodId) {
		return _.filter(this.players, function(player) {
			return !player.drafted;
		});
	};
	
	PlayerList.prototype.searchDraftablePlayers = function (queryStr, limitPositions, showDraftedPlayers) {
		if (typeof(showDraftedPlayers)==='undefined') showDraftedPlayers = false;
		
		this.tmpPositions = limitPositions || [];
		var attrRank = 'OVRRANK';
		var result = _.filter(this.players, function(player) {
				var tokens = queryStr.split(" ");
				var queryMatches = true;
				
				if(player.drafted && !showDraftedPlayers){
					return false;
				}
				
				//If positions wasn't provided go ahead and return true
				if(this.tmpPositions.length > 0 && _.intersection(this.tmpPositions,player.position.split(',')).length == 0){
					return false;
				}
				
				for(var i = 0; i < tokens.length; i++) {
					var searchElement = tokens[i];
					
					if(player.dispName.toLowerCase().indexOf(searchElement.toLowerCase()) == -1
							&& player.teamFullName.toLowerCase().indexOf(searchElement.toLowerCase()) == -1){
						queryMatches = false;
					}
				}
			
				return queryMatches;
			}, this).sort(function(first, last) {
				if(first.attrs 
						&& last.attrs
						&& first.attrs[attrRank] 
						&& parseInt(first.attrs[attrRank]) > 0 
						&& last.attrs[attrRank] 
						&& parseInt(last.attrs[attrRank]) > 0){
					if(parseInt(first.attrs[attrRank]) < parseInt(last.attrs[attrRank])){
						return -1;
					} else {
						return 1;
					}
				} else if(first.attrs && first.attrs[attrRank] && parseInt(first.attrs[attrRank]) > 0){
					return -1;
				} else if(last.attrs && last.attrs[attrRank] && parseInt(last.attrs[attrRank]) > 0){
					return 1;
				} else if(first.dispName.toLowerCase() < last.dispName.toLowerCase()){
					return -1;
				} else {
					return 1;
				}
			});
		
		delete this.tmpPositions;
		return result;
	};
	
	PlayerList.prototype.sortByRank = function (attrRank, includeDraftedPlayers, limitPositions) {
		this.tmpPositions = limitPositions || [];
		
		var result = null;
		
		if(attrRank == 'RKRANK'){
			result = this.sortByRookieAlpha(includeDraftedPlayers, limitPositions);
		} else {
			result =  _.sortBy(
					_.filter(this.players, function(player) {
						//Remove drafted players if includeDraftedPlayers is false
						if(!includeDraftedPlayers && player.drafted == true){
							return false;
						}
						//Remove players without a rank
						if(!player.attrs[attrRank] || player.attrs[attrRank] <= 0) {
							return false;
						}
						//If positions wasn't provided go ahead and return true
						if(this.tmpPositions.length == 0){
							return true;
						} else {
							return _.intersection(this.tmpPositions,player.position.split(',')).length > 0;
						}
					}, this), 
					function(player){ return parseInt(player.attrs[attrRank]);},
					this
			);
			
			if(!result || result.length == 0){
				delete this.tmpPositions;
				result = this.sortByAlpha(includeDraftedPlayers, limitPositions, null);
			}
		}
		
		delete this.tmpPositions;		
		return result;
	};
	
	PlayerList.prototype.sortByStat = function (statCat, includeDraftedPlayers, limitPositions) {
		this.tmpPositions = limitPositions || [];
		this.tmpStatCat = statCat;
		
		var result =  _.sortBy(
				_.filter(this.players, function(player) {
					//Remove drafted players if includeDraftedPlayers is false
					if(!includeDraftedPlayers && player.drafted == true){
						return false;
					}
					//Remove players without a rank
					//if(!player.projectedStats || !player.projectedStats[this.tmpStatCat] || !player.projectedStats[this.tmpStatCat]['CONSENSUS']) {
					//	return false;
					//}
					//If positions wasn't provided go ahead and return true
					if(this.tmpPositions.length == 0){
						return true;
					} else {
						return _.intersection(this.tmpPositions,player.position.split(',')).length > 0;
					}
				}, this), 
				function(player){
					var statValue = 0;
					if(player.projectedStats && player.projectedStats[this.tmpStatCat] && player.projectedStats[this.tmpStatCat]['CONSENSUS']) {
						statValue = player.projectedStats[this.tmpStatCat]['CONSENSUS'];
					}
					
					return parseFloat(statValue);
				},
				this
		);
		
		delete this.tmpStatCat;
		delete this.tmpPositions;		
		return result;
	};
	
	PlayerList.prototype.sortByAlpha = function (includeDraftedPlayers, limitPositions, excludeAttrRank) {
		this.tmpPositions = limitPositions || [];
		var result = _.sortBy(
				_.filter(this.players, function(player) {
					//Remove drafted players if includeDraftedPlayers is false
					if(!includeDraftedPlayers && player.drafted == true){
						return false;
					}
					//Filter out the excluded attr, if provided
					if(excludeAttrRank 
							&& excludeAttrRank != '' 
							&& player.attrs 
							&& player.attrs[excludeAttrRank] 
							&& parseInt(player.attrs[excludeAttrRank]) > 0 ){
						return false;
					}
					//If positions wasn't provided go ahead and return true
					if(this.tmpPositions.length == 0){
						return true;
					} else {
						return _.intersection(this.tmpPositions,player.position.split(',')).length > 0;
					}
				}, this), 
				function(player){ return player.lastName + ' ' + player.firstName;},
				this
		);
		
		delete this.tmpPositions;
		return result;
	};
	
	PlayerList.prototype.sortByRookieAlpha = function (includeDraftedPlayers, limitPositions) {
		this.tmpPositions = limitPositions || [];
		var result = _.sortBy(
				_.filter(this.players, function(player) {
					//Remove drafted players if includeDraftedPlayers is false
					if(!includeDraftedPlayers && player.drafted == true){
						return false;
					}
					//if(player.teamAbbr != 'RK'){
					//	return false;
					//}
					if(player.exp != 0){
						return false
					}
					//If positions wasn't provided go ahead and return true
					if(this.tmpPositions.length == 0){
						return true;
					} else {
						return _.intersection(this.tmpPositions,player.position.split(',')).length > 0;
					}
				}, this), 
				function(player){ return player.lastName + ' ' + player.firstName;},
				this
		);
		
		delete this.tmpPositions;
		return result;
	};
	
	PlayerList.prototype.sortByCategory = function (sortCategory, rankAttr, isSortAsc, includeDraftedPlayers, limitPositions, teamAbbr, isRookie, isOnlyRkEnabled) {
		var sortedList;
		
		switch (sortCategory) {
		case "ALPHA": 
			var result = this.sortByAlpha(includeDraftedPlayers, limitPositions, null);
			if(isSortAsc){
				sortedList = result;
			} else {
				sortedList = result.reverse();
			}
			break; 			
		case "OVRRANK": 
			var result = this.sortByRank('OVRRANK', includeDraftedPlayers, limitPositions);
			if(isSortAsc){
				sortedList = result;
			} else {
				sortedList = result.reverse();
			}
			break;
		case "POSRANK": 
			var result = this.sortByRank(rankAttr, includeDraftedPlayers, limitPositions);
			if(isSortAsc){
				sortedList = result;
			} else {
				sortedList = result.reverse();
			}
			break;
		default:	
			var result = this.sortByStat(sortCategory, includeDraftedPlayers, limitPositions);
			if(isSortAsc){
				sortedList = result;
			} else {
				sortedList = result.reverse();
			}
			break;
		};
		
		if(teamAbbr && teamAbbr != '' && teamAbbr != 'ALL'){
			var additionalResults = [];
			if(sortCategory == "OVRRANK"){
				additionalResults = this.sortByAlpha(includeDraftedPlayers, limitPositions, "OVRRANK");
			} else if(sortCategory == "POSRANK"){
				additionalResults = this.sortByAlpha(includeDraftedPlayers, limitPositions, rankAttr);
			}
			
			this.sortedList = _.union(sortedList, additionalResults);
			var newList = _.filter(this.sortedList, function(player) {
				if(player.teamAbbr != teamAbbr){
					return false
				} else {
					return true;
				}
			}, this);
			delete this.sortedList;
			sortedList = newList;
		} else if(isOnlyRkEnabled){
			var additionalResults = [];
			if(sortCategory == "OVRRANK"){
				additionalResults = this.sortByAlpha(includeDraftedPlayers, limitPositions, "OVRRANK");
			} else if(sortCategory == "POSRANK"){
				additionalResults = this.sortByAlpha(includeDraftedPlayers, limitPositions, rankAttr);
			}
			
			sortedList = _.union(sortedList, additionalResults);
		}
		
		if(isRookie){
			this.sortedList = sortedList;
			var newList = _.filter(this.sortedList, function(player) {
				if(player.exp != 0){
					return false
				} else {
					return true;
				}
			}, this);
			delete this.sortedList;
			sortedList = newList;
		}
		
		return sortedList;
	};
	
	return PlayerList;
});